import { useBroadcastChannel } from '@vueuse/core'
import { watch } from 'vue'

const CHANNEL_NAME = 'APP_GLOBAL_BUS'

// 1. 创建一个单例的广播通道（在模块顶层，不依赖组件生命周期）
const { data, post } = useBroadcastChannel<any, any>({ name: CHANNEL_NAME })

/**
 * 极简发送：可以在任何地方执行（点击事件、接口回调等）
 */
export const emitCrossTab = (type: string, payload?: any) => {
  post({ type, payload })
}

/**
 * 极简监听：useCrossTabListen('TYPE', callback)
 */
export function useCrossTabListen(type: string, callback: (payload?: any) => void) {
  // 监听广播数据的变化
  watch(data, newMessage => {
    if (newMessage && newMessage.type === type) {
      callback(newMessage.payload)
    }
  })
}
